import React, { Component } from "react";
import axios from "axios";
import { routes } from "../General";
import { Modal, ModalBody } from "reactstrap";
import { Contratante } from "./Contratante";
import { DocsDigitalTabla } from "../siniestros/DocsDigitalTabla";

export class DocDigitales extends Component {
    constructor(props) {
        super(...arguments);
        this.state = {
            docdigital: [],
            docminio: [],
        };
    }

    componentDidUpdate(prevProps) {
        let { open } = this.props;
        let openOld = prevProps.open;

        if (open !== openOld) {
            if (open) {
                this.fetchData();
            } else {
                this.setState({ item: {} });
            }
        }
    }

    onClose = () => {
        this.fetchData();
    };

    fetchData() {
        let docItem = this.props.poliza.cotizacion;
        this.getDocDigital(
            docItem.cdCliente,
            docItem.cdCompania,
            docItem.cdCotizacion,
            docItem.numCotizacion,
            this.props.poliza.poliza
        );
    }

    closeModal = () => {
        this.props.toggleModal(false);
        this.setState({ list: [], item: {} });
    };

    getDocDigital = (cdcliente, cdcompania, cdcotizacion, numCotizacion, poliza) => {
        axios
            .get(routes.api + "/docs", {
                params: {
                    tipo: "poliza",
                    cdCliente: cdcliente,
                    cdCompania: cdcompania,
                    cdCotizacion: cdcotizacion,
                    numCotizacion: numCotizacion,
                    poliza: poliza,
                    anexo: this.props.item.anexo,
                },
            })
            .then(resp => {
                let res = resp.data;
                res.minio.map(rp => {
                    rp.metadato = JSON.stringify(rp.metadato);
                });
                this.setState({ docminio: res.minio });
                (res.minio || []).forEach(datosTabla => {
                    datosTabla.metadato = JSON.parse(datosTabla.metadato);
                    //Se encuentra doble serializado el JSON
                    datosTabla.metadato = JSON.parse(datosTabla.metadato);
                });
                this.setState({ docdigital: res });
            })
            .catch(error => {
                // alert('Error al consultar' + error);
            });
    };

    render() {
        let ramos = this.props.ramos;
        return (
            <Modal className="text-center modal-xl mx-auto modal-detail " isOpen={this.props.open}>
                <ModalBody>
                    <div className="row">
                        <Contratante
                            poliza={this.props.poliza}
                            item={this.props.item}
                            user={this.props.user}
                            vida={this.props.vida}
                            ramos={ramos}
                        />

                        <div className="col-lg-9">
                            <div className={"text-right"}>
                                <button
                                    type="button"
                                    className="close"
                                    title="Cerrar"
                                    onClick={this.closeModal}
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <h5 className="card-title">Documentos Digitales</h5>
                            <DocsDigitalTabla
                                docdigital={this.state.docdigital}
                                docminio={this.state.docminio}
                                dato={{
                                    ...this.props.poliza.cotizacion,
                                    poliza: this.props.poliza.poliza,
                                    anexo: this.props.item.anexo,
                                }}
                                tipo={"poliza"}
                                ocultarAcordeon={true}
                                onClose={this.onClose}
                            />
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}
